module.exports = __webpack_public_path__ + "img/one_4.a66be32a.png";